import { memo } from "react"

export const ComponentList = memo(() => {
  return <div>ComponentList</div>
})